var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.0212C3.75 9.02375 3.75 7.025 4.2225 6.3525C4.69375 5.68125 6.5725 5.0375 10.3313 3.75125L11.0475 3.50625C13.0063 2.835 13.985 2.5 15 2.5C16.0137 2.5 16.9937 2.835 18.9525 3.50625L19.6687 3.75125C23.4275 5.0375 25.3062 5.68125 25.7775 6.3525C26.25 7.025 26.25 9.025 26.25 13.0212V14.9888C26.25 22.0363 20.9512 25.4575 17.6262 26.9088C16.725 27.3025 16.275 27.5 15 27.5C13.725 27.5 13.275 27.3025 12.3738 26.9088C9.04875 25.4563 3.75 22.0375 3.75 14.9888V13.0212Z",
    stroke: "#35A8E0",
    strokeWidth: 2.1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 15.5L13.6612 17.5L18.125 12.5",
    stroke: "#35A8E0",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsIcon);
export default __webpack_public_path__ + "static/media/controls_icon.8c87692e3546c14291dccdd8cbbdeb7d.svg";
export { ForwardRef as ReactComponent };